import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
const painPoints = ['Duermes, pero te levantas cansado/a, como si no hubieras descansado de verdad.', 'Tu mente se siente lenta, con niebla mental, y te cuesta enfocarte.', 'A mitad del día, te cae un bajón de energía.', 'Sientes que tu cuerpo tarda más en recuperarse después de hacer ejercicio o de una semana intensa.', 'Por la noche, tu sueño es ligero, te despiertas varias veces, o te cuesta conciliarlo.', 'Y a veces, sientes que vives en "modo alerta": más tensión, más irritabilidad, sin una razón clara.'];
export function PainPoints() {
  return <section className="py-16 md:py-24 bg-[#0d0d0d] relative overflow-hidden" data-id="element-148">
      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-150">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-151">
            ¿Te Suena <span className="text-red-500" data-id="element-152">Familiar?</span>
          </h2>
          <div className="h-1 w-20 bg-red-600 mx-auto rounded-full" data-id="element-153" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-154">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 p-4 md:p-6 rounded-xl bg-[#151515] border border-white/5" data-id="element-155">
              <AlertCircle className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-156" />
              <p className="text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-157">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-red-900/20 to-transparent border-l-4 border-red-600 p-5 md:p-8 rounded-r-xl" data-id="element-158">
          <p className="text-lg md:text-2xl font-semibold text-white mb-3 md:mb-4" data-id="element-159">
            No es flojera. No es solo la edad.
          </p>
          <p className="text-base md:text-lg text-gray-300" data-id="element-160">
            Lo que le está pasando a tu cuerpo es que está{' '}
            <span className="text-red-400 font-bold" data-id="element-161">desregulado</span>. Tu
            ritmo interno perdió sintonía con su ambiente.
          </p>
        </motion.div>
      </div>
    </section>;
}